import { Fab } from '../primitives/fab.js'
import type { FabProps } from '../primitives/fab.js'
import { Upload } from '@tunasong/icons'
import type { Entity, Persisted } from '@tunasong/schemas'
import { useRef } from 'react'
import { useUploadFiles } from '../upload/upload-files.hook.js'

export interface UploadFabButtonProps extends Omit<FabProps, 'onClick'> {
  parent: Persisted<Entity>
}

export const UploadFabButton = (props: UploadFabButtonProps) => {
  const { parent, ...restProps } = props

  const { handleChange } = useUploadFiles()

  const uploadRef = useRef<HTMLInputElement | null>(null)
  const handleClick = () => uploadRef.current?.click()

  return (
    <>
      <input ref={uploadRef} type="file" multiple={true} accept={'audio/*'} hidden onChange={handleChange(parent.id)} />
      <Fab aria-label="Upload" onClick={handleClick} {...restProps}>
        <Upload />
      </Fab>
    </>
  )
}
